import { render, staticRenderFns } from "./VacancyCandidatesPrehired.vue?vue&type=template&id=89c7ad58&scoped=true"
import script from "./VacancyCandidatesPrehired.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesPrehired.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesPrehired.vue?vue&type=style&index=0&id=89c7ad58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c7ad58",
  null
  
)

export default component.exports